import { type RouteMeta, type RouteRecordRaw } from 'vue-router'

const printShopEmbedMeta: RouteMeta = {
  authZ: ({ user }) => user.can('create', 'physical-media'),
  title: 'marketing.print-shop',
}

export const printShopEmbedRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/PrintShopEmbedView.vue'),
    meta: { ...printShopEmbedMeta },
    name: 'brand.marketing.print-shop',
    path: 'marketing/print-shop/:view(goal|design|order)?',
  },
  {
    component: async () => import('../views/PrintShopEmbedView.vue'),
    meta: { ...printShopEmbedMeta },
    name: 'brand.marketing.print-shop.quote',
    path: 'marketing/print-shop/quotes/:quoteId',
  },
  {
    component: async () => import('../views/PrintShopEmbedView.vue'),
    meta: { ...printShopEmbedMeta },
    name: 'brand.marketing.print-shop.checkout',
    path: 'marketing/print-shop/quotes/:quoteId/checkout',
  },
]
